import { FC, useContext } from 'react';
import { Icon } from '@aidkitorg/component-library';
import { NavLink } from 'react-router-dom';
import { useLocalizedStrings } from '../../../../Localization';
import InterfaceContext from '../../../../Context';
import { getStageFromUid } from '../shared/utils';
import { ContextSectionProps } from '../shared/types';
import { InfoField } from './InfoField';

/**
 * Context section showing contact info, case details, and applicant information
 */
export const ContextSection: FC<ContextSectionProps> = ({
  caseInfo,
  applicantInfo,
  applicantUid,
  verifiedContacts
}) => {
  const L = useLocalizedStrings();
  const context = useContext(InterfaceContext);

  return (
    <div className="pb-6 border-b border-gray-200 min-w-0">
      <h3 className="text-sm font-semibold text-gray-500 uppercase mb-3">{L.support.context}</h3>
      <div className="space-y-3 min-w-0">
        {applicantUid && (
          <NavLink
            to={`/admin-panel/a/${applicantUid}`}
            target="_blank"
            className="text-[var(--ak-color-typography-link)] hover:text-[var(--ak-color-typography-link-hover)] font-medium inline-flex items-center gap-2"
          >
            {L.support.view_application}
            <Icon size="sm" role="decorative" name="ArrowTopRightOnSquareIcon" />
          </NavLink>
        )}

        <InfoField
          label={L.support.phone_number}
          value={applicantInfo?.['phone_number'] || (!caseInfo.contact.includes('@') ? caseInfo.contact : '-')}
          verified={!!(applicantInfo?.['phone_number'] && (verifiedContacts || []).includes(applicantInfo?.['phone_number']))}
        />

        <InfoField
          label={L.support.email}
          value={applicantInfo?.['email'] || (caseInfo.contact.includes('@') ? caseInfo.contact : '-')}
          verified={!!(applicantInfo?.['email'] && (verifiedContacts || []).includes(applicantInfo?.['email']))}
        />

        <InfoField
          label={L.support.applicants_name}
          value={applicantInfo?.['legal_name'] || '-'}
        />

        <InfoField
          label={L.support.case_created}
          value={
            caseInfo.created_at
              ? new Date(caseInfo.created_at).toLocaleString(context.lang.replaceAll('_', '-'))
              : L.support.na
          }
        />

        <InfoField
          label={L.support.applicant_stage}
          value={getStageFromUid(applicantUid, L.application_stage)}
        />

        {applicantInfo?.['language'] && (
          <InfoField
            label={L.support.language_spoken}
            value={applicantInfo?.['language']}
          />
        )}
      </div>
    </div>
  );
};
